import { render, staticRenderFns } from "./_DeleteProduct.vue?vue&type=template&id=0a0a2ec6&scoped=true&"
import script from "./_DeleteProduct.vue?vue&type=script&lang=js&"
export * from "./_DeleteProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0a2ec6",
  null
  
)

export default component.exports